// A2F-764: numeric stepper for size / spacing / indent fields.
//
// Wider hit-target than the FieldCard NumberInput in v1 (which packs a
// 14px-wide <input> next to the unit). Two big +/- buttons + a static
// readout matches Word's own ribbon stepper UX more closely.

interface StepperProps {
  value: number
  min: number
  max: number
  step?: number
  unit?: string
  /** A11y label — e.g. "H1 size". */
  ariaLabel: string
  onChange: (next: number) => void
}

export function Stepper({
  value,
  min,
  max,
  step = 1,
  unit = 'pt',
  ariaLabel,
  onChange,
}: StepperProps) {
  const atMin = value <= min
  const atMax = value >= max
  return (
    <div
      className="inline-flex items-center rounded-lg border border-slate-200 bg-white"
      role="group"
      aria-label={ariaLabel}
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - step))}
        disabled={atMin}
        aria-label={`Decrease ${ariaLabel}`}
        className="px-3 py-1.5 text-slate-500 hover:text-brand-charcoal disabled:opacity-30 disabled:cursor-not-allowed"
      >
        −
      </button>
      <span
        className="px-3 py-1.5 text-[13px] tabular-nums text-brand-charcoal border-x border-slate-200 min-w-[64px] text-center"
        aria-live="polite"
      >
        {Number.isInteger(value) ? value : value.toFixed(1)}
        {unit}
      </span>
      <button
        type="button"
        onClick={() => onChange(Math.min(max, value + step))}
        disabled={atMax}
        aria-label={`Increase ${ariaLabel}`}
        className="px-3 py-1.5 text-slate-500 hover:text-brand-charcoal disabled:opacity-30 disabled:cursor-not-allowed"
      >
        +
      </button>
    </div>
  )
}
